import { Box, DialogContentText, MenuItem, Select, SelectChangeEvent, Stack, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { ITaskType, ITaskDetails, ICylinder } from '../../interface/IOrders_Tasks';
import { useSelector } from 'react-redux';
import { IUser } from '../../interface/IUser';
import { ITaskStatus } from '../../interface/ITask';
import { v4 as uuid } from 'uuid';
import DialogCreateRma from './DialogEditRma';
import { AxiosInstance } from '../../api/apiInstance';

function TaskCreateDialog(props: any) {
    const [cylinderData, setCylinderData] = React.useState<ICylinder[]>([] as ICylinder[]);
    const [singleTaskCreate, setSingleTaskCreate] = useState<ITaskDetails>();
    const taskType: ITaskType[] = useSelector((state: any) => state.taskType)
    const TaskUsers: IUser[] = useSelector((state: any) => state.allUsers)
    const [taskTypeSelected, setTaskTypeSelected] = useState<string>('Inventory count');
    const userinfo: IUser = useSelector((state: any) => state.user)
    //const [userSelected, setUserSelected] = useState<string>('');
    useEffect(() => {
        const tmpCreate = {} as ITaskDetails;
        GetData();
        tmpCreate.taskType = taskType[1];
        // if (userinfo.userRoleName !=='Administrator')
        // {
        //     setTaskTypeSelected('Inventory count')
        //     tmpCreate.taskType  =  taskType[1];

        // }
        // else{
        //     setTaskTypeSelected('Assembly')
        //     tmpCreate.taskType  =  taskType[0];
        // }
        tmpCreate.id = uuid();
        tmpCreate.taskStatus = taskStatus.find((t) => { if (t.id === 1) return true; }); // new
        if (userinfo.userRoleName === 'Administrator')
            tmpCreate.user = TaskUsers[1];
        else
            tmpCreate.user = TaskUsers.find((t) => { if (t.id === userinfo.id) return true; });


        setSingleTaskCreate(tmpCreate)
    }, []);


    async function GetData() {
        await AxiosInstance({
            // url of the api endpoint (can be changed)
            url: "cylinder",
            method: "GET",
        }).then((res) => {
            // handle success
            const AllData = res.data as ICylinder[];
            setCylinderData(AllData);
        })
    }
    const taskStatus: ITaskStatus[] = useSelector((state: any) => state.taskStatus)
    //
    const handleTaskTypeChange = (event: SelectChangeEvent) => {
        setTaskTypeSelected(event.target.value as string);
        setDialogCreateingleTask(event);
    };
    function setDialogCreateingleTask(e: any) {
        const tmpCreate = { ...singleTaskCreate }
        //tmpCreate.taskStatus = taskStatus.find((t) => { if (t.id === 1) return true; }); // new            
        if (e.target.name === 'taskType')
            tmpCreate.taskType = taskType.find((t) => { if (t.role === e.target.value) return true; return false });
        else if (e.target.name === 'userName') {
            if (userinfo.userRoleName === 'Administrator')
                tmpCreate.user = TaskUsers.find((t) => { if (t.id === e.target.value) return true; });
        }
        else
            tmpCreate[e.target.name] = e.target.value;
        setSingleTaskCreate(tmpCreate)

        props.setDialogCreateSingleTask(tmpCreate);
    }

    return (
        <div>
            {/* task Type */}
            <Box sx={{ my: 2 }}>
                {props.rowData?.taskType?.role}
                <DialogContentText variant="h6">task type</DialogContentText>
                <Select sx={{ width: '80%' }}
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={taskTypeSelected}
                    label="task type"
                    name="taskType"

                    onChange={handleTaskTypeChange}
                >
                    {
                        taskType.map((item, pos) => {
                            return (
                                <MenuItem key={pos} value={item.role}>
                                    {item.role}
                                </MenuItem>
                            )
                        })
                    }
                    {/* taskType.filter((tt) => { if (tt.id === 2) return true; return false; }).map((item, pos) => {
                            return (
                                <MenuItem key={pos} value={item.role}>
                                    {item.role}
                                </MenuItem>
                            )
                        }) */}
                </Select>
            </Box>

            <Box sx={{ my: 2 }}>
                {/* <DialogContentText variant="h6">{
                    taskTypeSelected === 'Good received' ? 'Title (Po)' : 'Title'}</DialogContentText> */}
                <TextField
                    id="DataInfo"
                    type="text"
                    label={taskTypeSelected === 'Good received' ? 'Title (Po)' : 'Title'}
                    fullWidth
                    variant="outlined"
                    name="DataInfo"
                    onChange={event => setDialogCreateingleTask(event)}
                    value={singleTaskCreate?.DataInfo} />
            </Box>
            {/* Assembly */}
            {taskTypeSelected === 'Assembly' || taskTypeSelected === 'Picking' ?
                <>
                    {/* Part No */}
                    <Box sx={{ my: 2 }}>
                        {/* <DialogContentText variant="h6">Part Number</DialogContentText> */}
                        <TextField
                            autoFocus
                            id="PartNo"
                            label="Part Number"
                            type="text"
                            fullWidth
                            variant="outlined"
                            name="PartNumber"
                            onChange={event => setDialogCreateingleTask(event)}
                            value={singleTaskCreate?.PartNumber}
                        />
                    </Box>
                    <Box sx={{ my: 2 }}>
                        {/* <DialogContentText variant="h6">Quantity to assemble</DialogContentText> */}
                        <TextField
                            id="Quantity-to-assemble"
                            label="Quantity to assemble"
                            type="text"
                            fullWidth
                            variant="outlined"
                            name="QTYtoassemble"
                            onChange={event => setDialogCreateingleTask(event)}
                            value={singleTaskCreate?.QTYtoassemble}

                        //onChange={event => setErrorName(event.target.value)}
                        //value={''}
                        />
                    </Box>

                    <Box>
                        <DialogContentText  variant="h6">key Type</DialogContentText>
                        <Select
                            sx={{ mt: 1 }}

                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            value={singleTaskCreate?.cylinder || 'Not-Needed'}
                            
                            name="cylinder"
                            onChange={event => setDialogCreateingleTask(event)}

                        >
                            {cylinderData.map((c) => {
                                return (
                                    <MenuItem value={c.partName}>{c.partName + ' ' + c.description}</MenuItem>
                                )
                            })}

                        </Select>
                    </Box>
                </> : <></>}
            {/* Assembly Order */}
            {taskTypeSelected === 'Inventory count' ||
                taskTypeSelected === 'Inventory count - Poland' ||
                taskTypeSelected === 'Inventory count - US' ?
                <>
                    <Box sx={{ my: 2 }}>
                        {/* <DialogContentText variant="h6">Location</DialogContentText> */}
                        <TextField
                            autoFocus
                            id="Location"
                            label="Location"
                            type="text"
                            fullWidth
                            variant="outlined"
                            name="Location"
                            onChange={event => setDialogCreateingleTask(event)}
                            value={singleTaskCreate?.Location}
                        />
                    </Box>
                    {/* Part No */}
                    <Box sx={{ my: 2 }}>
                        {/* <DialogContentText variant="h6">Part Number</DialogContentText> */}
                        <TextField
                            autoFocus
                            id="PartNumber"
                            label="Part Number"
                            type="text"
                            fullWidth
                            variant="outlined"
                            name="PartNumber"
                            onChange={event => setDialogCreateingleTask(event)}
                            value={singleTaskCreate?.PartNumber}
                        />
                    </Box>

                </> : <></>}

            {/* Assembly Order */}
            {taskTypeSelected === 'Assembly Order' ? <>
                {/* Part No */}
                <Box sx={{ my: 2 }}>
                    {/* <DialogContentText variant="h6">Part Number</DialogContentText> */}
                    <TextField
                        autoFocus
                        id="PartNumber"
                        label="Part Number"
                        type="text"
                        fullWidth
                        variant="outlined"
                        name="PartNumber"
                        onChange={event => setDialogCreateingleTask(event)}
                        value={singleTaskCreate?.PartNumber}
                    />
                </Box>
                <Box sx={{ my: 2 }}>
                    {/* <DialogContentText variant="h6">Order Number</DialogContentText> */}
                    <TextField
                        autoFocus
                        label="Order Number"
                        id="Order Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        name="orderName"
                        onChange={event => setDialogCreateingleTask(event)}
                        value={singleTaskCreate?.orderName}
                    />
                </Box>
                <Box sx={{ my: 2 }}>
                    {/* <DialogContentText variant="h6">Quantity to assemble</DialogContentText> */}
                    <TextField
                        label="Quantity to assemble"
                        id="Quantity-to-assemble"
                        type="text"
                        fullWidth
                        variant="outlined"
                        name="QTYtoassemble"
                        onChange={event => setDialogCreateingleTask(event)}
                        value={singleTaskCreate?.QTYtoassemble}

                    //onChange={event => setErrorName(event.target.value)}
                    //value={''}
                    />
                </Box>
                <Box>
                        <DialogContentText  variant="h6">key Type</DialogContentText>
                        <Select
                            sx={{ mt: 1 }}

                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            value={singleTaskCreate?.cylinder || 'Not-Needed'}
                            
                            name="cylinder"
                            onChange={event => setDialogCreateingleTask(event)}

                        >
                            {cylinderData.map((c) => {
                                return (
                                    <MenuItem value={c.partName}>{c.partName + ' ' + c.description}</MenuItem>
                                )
                            })}

                        </Select>
                    </Box>
            </> :
                <></>}
            {taskTypeSelected === 'Good received' ?
                <>
                    <Box sx={{ my: 2 }}>
                        {/* <DialogContentText variant="h6">Location</DialogContentText> */}
                        <TextField
                            autoFocus
                            id="Location"
                            label="Location"
                            type="text"
                            fullWidth
                            variant="outlined"
                            name="Location"
                            onChange={event => setDialogCreateingleTask(event)}
                            value={singleTaskCreate?.Location}
                        />
                    </Box>
                    <Box sx={{ my: 2 }}>
                        {/* <DialogContentText variant="h6">Part Number</DialogContentText> */}
                        <TextField
                            autoFocus
                            id="PartNo"
                            label="Part Number"
                            type="text"
                            fullWidth
                            variant="outlined"
                            name="PartNumber"
                            onChange={event => setDialogCreateingleTask(event)}
                            value={singleTaskCreate?.PartNumber}
                        />
                    </Box>
                    <Box sx={{ my: 2 }}>
                        {/* <DialogContentText variant="h6">Supplier</DialogContentText> */}
                        <TextField
                            autoFocus
                            id="Supplier"
                            type="text"
                            label="Supplier"
                            fullWidth
                            variant="outlined"
                            name="Supplier"
                            onChange={event => setDialogCreateingleTask(event)}
                            value={singleTaskCreate?.Supplier}
                        />
                    </Box>

                </> : <></>}
            {taskTypeSelected === 'Warehouse changes' ?
                <Box sx={{ my: 2 }}>
                    {/* <DialogContentText variant="h6">task Info</DialogContentText> */}
                    <TextField
                        variant="outlined"
                        autoFocus
                        label="task Info"
                        multiline
                        rows={4}
                        id="taskInfo"
                        //label="Part No"
                        type="text"
                        fullWidth
                        name="taskInfo"
                        onChange={event => setDialogCreateingleTask(event)}
                        value={singleTaskCreate?.taskInfo}
                    />
                </Box>
                : <></>}

            {/* {taskTypeSelected === 'RMA' ?
                <>
                  
                </> : <></>
            } */}


            <Box sx={{ my: 2 }}>
                <DialogContentText variant="h6">User</DialogContentText>
                <Select sx={{ width: '90%' }}

                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={userinfo.userRoleName === 'Administrator' ?
                        singleTaskCreate?.user ? singleTaskCreate?.user?.id : TaskUsers[1].id
                        : userinfo.id
                    }
                    label="User"

                    name="userName"
                    onChange={event => setDialogCreateingleTask(event)}
                >
                    {userinfo.userRoleName === 'Administrator' ?
                        TaskUsers.filter((ts) => { if (ts.id > 1) return true; return false; }).
                            map((item, pos) => {
                                return (
                                    <MenuItem key={pos} value={item.id}>
                                        {item.userName}
                                    </MenuItem>
                                )
                            })
                        :

                        TaskUsers.filter((ts) => { if (ts.id === userinfo.id) return true; return false; }).
                            map((item, pos) => {
                                return (
                                    <MenuItem key={pos} value={item.id}>
                                        {item.userName}
                                    </MenuItem>
                                )
                            })
                    }

                </Select>
            </Box>
        </div>
    )
}

export default TaskCreateDialog
